import { render, staticRenderFns } from "./mortgageForm.vue?vue&type=template&id=4ba5f4b4&"
import script from "./mortgageForm.vue?vue&type=script&lang=js&"
export * from "./mortgageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports